module.exports = __webpack_public_path__ + "static/SuisseIntl-SemiBold-6655ddea3d58f8aba036f18a56b697d6.otf";